import axios from "axios";
import axiosInstance from "../../Hooks/axoisInstance";
import { API_BASE_URL, API_BASE_URL1 } from "../Services/baseApiUrl";
//const countryId =localStorage.getItem("country_Id");
import { toast } from "react-toastify";
const getToken = () => {
  return localStorage.getItem("token");
};

export const AllDriverDetails = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetDriverDetails`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
   
  }
};




export const AddDriverDetails = async (driverData) => {
  try {
    const response = await axiosInstance.post(API_BASE_URL1 + `MasterCreate/AddDriverDetails`, driverData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },

      })
    return response;
  } catch (error) {
    throw error;
   
  }
};

export const UpdateDriverDetails = async (driverData) => {
  try {
    const response = await axiosInstance.put(API_BASE_URL1 + `MasterCreate/UpdateDriverDetails`, driverData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
          "Content-Type": "multipart/form-data",
        },

      });

    // const successMessage = 'Driver Details Updated Successfully'
    // toast.success(successMessage, {
    //     position: 'top-right',
    //     autoClose: 3000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    // })

    // if (!response.ok) {
    //   throw new Error("Failed to add Shift");
    // }

    return response;
  } catch (error) {
    throw error;
   
  }
};

export const getDriverById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `driver/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error
   
  }
};